import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {BookOfShadowsParsedGameData} from "../../server/data/BookOfShadowsParsedGameData";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {BookOfShadowsReTriggerView} from "./BookOfShadowsReTriggerView";
import {SoundManager} from "../../sound/SoundManager";
import {TweenLite} from "gsap";

export class BookOfShadowsReTriggerController extends GameModeTransitionController {
    private _view: BookOfShadowsReTriggerView;

    /**
     * @constructs
     * @param fromMode
     * @param toMode
     */
    constructor(fromMode: string, toMode: string) {
        super(fromMode, toMode);

        this._view = new BookOfShadowsReTriggerView(StageManager.getLayer(BookOfShadowsGameConfig.instance.LAYERS.FREE_SPIN.name), () => this.finish());
    }

    /**
     * @inheritDoc
     * @override => To call the finish once the view is done.
     */
    public start(): void {
        TweenLite.delayedCall(BookOfShadowsGameConfig.instance.ABORT_DELAY, () => this.startAfterDelay());
    }

    /**
     * @inheritDoc
     * @override To add the condition for re-trigger.
     * @param data
     */
    protected calculateIsTriggered(data: BookOfShadowsParsedGameData): boolean {
        const isReTriggered: boolean = ((data.addedNumberOfFreespinsThisSpin > 0) && (data.nearWinReels.indexOf(true) > -1) && (data.scatterPositions!.filter((val: number) => (val > -1)).length > 2));

        return super.calculateIsTriggered(data) && isReTriggered;
    }

    /**
     * @inheritDoc
     */
    protected finish(): void {
        this._view.cleanUp();

        super.finish();
    }

    // we don't want to hide/show keypad for this transition.
    protected hideKeypad(): void {
    }

    // we don't want to hide/show keypad for this transition.
    protected showKeypad(): void {
    }

    /**
     * @description To start after the abort is done.
     */
    private startAfterDelay(): void {
        BookOfShadowsGameConfig.instance.ABORT_DELAY = 0;

        this.prepareToEnterMode();

        SoundManager.playFSReTrigger();
        this._view.playScatterReTriggerAnimation((this._serverData as BookOfShadowsParsedGameData).fsSpecialSymbol, (this._serverData as BookOfShadowsParsedGameData).addedNumberOfFreespinsThisSpin);
    }
}